/**
 * Money formatting and parsing for the practitioner dashboard — one copy.
 *
 * There were five `fmtMoney` definitions across the admin tree and they did not agree:
 * two defaulted the currency to "cad", one to "" (so an unknown currency rendered a bare
 * number), one took it as a default parameter, and TaxAdmin hardcoded " $" — which is
 * simply wrong for a tenant billing in EUR or INR, and wrong silently, on the one screen
 * whose whole job is to tell a practitioner what they take home.
 *
 * `toCents` and `MIN_CENTS` were likewise duplicated. They exist because money inputs in
 * this dashboard are DOLLARS: two forms used to ask a human for cents, so typing 120.50
 * billed CA$1.20. Keeping the conversion in one place is what stops that returning.
 */

import { formatMoneyCode } from "../lib/formatMoney";

/** Smallest amount we will bill. Stripe rejects sub-minimum charges outright. */
export const MIN_CENTS = 50;

/** Dollars (string or number, possibly empty) -> integer cents. Never NaN-propagates. */
export const toCents = (major) => Math.round(Number(major || 0) * 100);

/** Integer cents -> "120.50 CAD". NO default currency (lib/formatMoney.js): a missing value
 *  renders the bare number rather than the retired settlement currency the old `"cad"`
 *  default stamped on it. Kept as a named export because ~all admin money passes here. */
export const fmtMoney = (cents, currency) => formatMoneyCode(cents, currency);
